import { RaFilterPanelState } from '../types';
import { raFilterPanelToHash } from './raFilterPanelToHash';

/* eslint-disable @typescript-eslint/no-use-before-define */
interface CommittedState {
  hash: string;
  blocked: boolean;
  committedSearchProps: RaFilterPanelState;
}

export const raFilterPanelChangeManager = changeManagerFn();

function changeManagerFn() {
  let onSubmitBlocked = () => {};
  const committedState: CommittedState = {
    hash: '',
    blocked: true,
    committedSearchProps: {
      activityRange: '',
      fraudType: '',
    },
  };

  return {
    isSubmittable,
    commitSearchProps,
    setSubmitBlocked,
    setOnSubmitBlocked,
    getCommittedSearchProps,
  };

  function getCommittedSearchProps(): RaFilterPanelState {
    return committedState.committedSearchProps;
  }

  function commitSearchProps(searchProps: RaFilterPanelState) {
    committedState.hash = raFilterPanelToHash(searchProps);
    committedState.committedSearchProps = searchProps;
  }

  function setSubmitBlocked(blocked: boolean) {
    committedState.blocked = blocked;
    onSubmitBlocked();
  }

  function setOnSubmitBlocked(callback: typeof onSubmitBlocked) {
    onSubmitBlocked = callback;
  }

  function isSubmittable(searchProps: RaFilterPanelState) {
    if (committedState.blocked) {
      return false;
    }

    return hasChanged(searchProps);
  }

  function hasChanged(state: RaFilterPanelState) {
    const hash = raFilterPanelToHash(state);
    return hash !== committedState.hash;
  }
}
